<template>
  <div class="row search m-0">
    <div
      v-show="displayFilter"
      id="catalog-filter"
      class="col catalog__filter p-0"
    >
      <div v-if="filter" class="filter-block">
        <filter-block
          ref="filter"
          :disable-save-button="disableSaveButton"
          :lock-save-button="lockSaveButton"
          @submit="filterSubmit"
        />
      </div>
    </div>
    <div v-if="catalogBlocksView" class="catalog__blocks p-0 col">
      <div v-if="!isLoaded" class="d-block preloader-block">
        <preloader />
      </div>

      <div class="catalog__blocks-wrap">
        <item v-for="item in items" :key="item.id" :item="item" />
        <h4 v-if="items.length === 0 && isLoaded" class="no-results-heading">
          {{ $t("No results") }}
        </h4>
      </div>
      <div
        v-if="displayPagination && items.length > 0"
        class="d-flex flex-wrap w-100 pagination-row justify-content-center"
      >
        <paginate
          v-model="params.page"
          :click-handler="setPage"
          :page-count="pages"
          container-class="pagination"
          next-class="page-item next"
          next-link-class="page-link"
          page-class="page-item"
          page-link-class="page-link"
          prev-class="page-item previous"
          prev-link-class="page-link"
        />
      </div>
    </div>

    <router-view name="company" />

    <div v-if="isCompany() || isSearch()" class="side-buttons">
      <router-link
        :to="{ name: 'main' }"
        class="side-buttons__button"
        tag="div"
        @click.native="goHome"
      >
        <i class="fa fa-times"></i>
      </router-link>
      <div class="side-buttons__button" @click="toggleDisplaySidebar()">
        <i v-if="sidebarDisplay" class="fa fa-chevron-left"></i>
        <i v-else class="fa fa-chevron-right"></i>
      </div>
    </div>
  </div>
</template>

<script>
import assign from "lodash-es/assign";
import Item from "./Item.vue";
import Paginate from "vuejs-paginate";
import FilterBlock from "./Filter.vue";
import isNull from "lodash-es/isNull";
import cloneDeep from "lodash-es/cloneDeep";
import pickBy from "lodash-es/pickBy";
import Map from "../Map.js";
import Preloader from "./Preloader.vue";

export default {
  name: "Search",

  components: {
    FilterBlock,
    Item,
    Paginate,
    Preloader,
  },

  props: {
    displayPagination: {
      type: Boolean,
      default: true,
    },
    displaySort: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      items: [],
      total: null,
      pages: 0,
      title: null,
      viewCounts: [],
      sorts: {},
      filter: true,
      filterParams: {},
      filterWatching: false,
      lockSaveButton: false,
      disableSaveButton: false,
      sidebarDisplay: true,
      sidebarElement: null,
      isLoaded: false,
    };
  },
  computed: {
    displayFilter() {
      let displayFilter = this.$store.getters.getDisplayFilter,
        sidebar = this.$store.getters.getRef("sidebar");

      if (typeof sidebar !== "undefined") {
        switch (true) {
          case displayFilter:
            sidebar.classList.add("filter-shown");
            break;
          case !displayFilter:
            sidebar.classList.remove("filter-shown");
            break;
        }
      }
      return displayFilter;
    },
    catalogFilterCol() {
      return this.$store.getters.getSearchCol("catalog_filter");
    },
    catalogResultsCol() {
      return this.$store.getters.getSearchCol("catalog_results");
    },
    params() {
      return this.$store.getters.getParameters;
    },
    catalogBlocksView() {
      return this.$store.getters.getCatalogBlocksView;
    },
  },
  created() {
    this.$store.commit("setDisplayFilter", false);
    this.$store.commit("setCompanyView", true);
  },
  mounted() {
    this.sidebarElement = $(".catalog .catalog-sidebar");

    if (this.$refs.filter) {
      this.$refs.filter.setOnLoadData();
    }

    this.$store.dispatch("setRefs", this);

    let top_search = this.$parent.$refs["top-search"],
      filter_btn = document.querySelector(".filter-btn");

    if (typeof top_search !== "undefined")
      top_search.style.removeProperty("display");

    this.windowActions();

    if (!this.isListening("search")) {
      filter_btn.addEventListener("click", (event) => {
        let filter = !this.$store.getters.getDisplayFilter;
        this.filterBehavior(filter);
      });

      window.addEventListener("popstate", (event) => {
        this.windowActions();
      });

      this.$store.commit("setPopstsateListener", {
        name: "search",
        value: true,
      });
    }

    this.setFields().then((r) => {
      if (this.$refs.filter) {
        setTimeout(() => {
          this.$refs.filter.startWatch();
        }, 500);

        this.$refs.filter.submit();
      }
    });

    this.setMetaTitles();
  },

  methods: {
    toggleDisplaySidebar(state) {
      let sidebarDisplay = this.sidebarDisplay,
        sidebar = this.sidebarElement,
        sidebarWidth = sidebar[0].offsetWidth;

      switch (true) {
        case state !== undefined:
          switch (state) {
            case true:
              if (sidebarDisplay) break;
              $(sidebar).animate(
                {
                  "margin-left": "+=" + sidebarWidth,
                },
                250,
                () => {
                  this.sidebarDisplay = state;
                }
              );
              break;
            case false:
              if (!sidebarDisplay) break;
              $(sidebar).animate(
                {
                  "margin-left": "-=" + sidebarWidth,
                },
                250,
                () => {
                  this.sidebarDisplay = state;
                }
              );
              break;
          }

          break;
        case sidebarDisplay:
          $(sidebar).animate(
            {
              "margin-left": "-=" + sidebarWidth,
            },
            250,
            () => {
              this.sidebarDisplay = !sidebarDisplay;
            }
          );
          break;
        case !sidebarDisplay:
          $(sidebar).animate(
            {
              "margin-left": "+=" + sidebarWidth,
            },
            250,
            () => {
              this.sidebarDisplay = !sidebarDisplay;
            }
          );
          break;
      }
    },

    load() {
      // disable save button
      this.disableSaveButton = true;
      delete this.filterParams.payment_method;

      this.$http
        .get("companies", {
          params: assign(
            {
              with: "saved",
            },
            this.params,
            this.filterParams
          ),
        })
        .then((response) => {
          this.items = response.data.data;
          this.total = response.data.meta.total;
          this.pages = response.data.meta.last_page;
          this.viewCounts = response.data.viewCounts;
          this.sorts = response.data.sorts;
          this.$refs.filter.hydrateFields(response.data.filter);

          this.lockSaveButton = !!response.data.savedSearch;
          //enable save button
          this.disableSaveButton = false;

          // update browser location
          const resUrl = response.request.responseURL;
          const queryString = resUrl.substring(resUrl.indexOf("?"));

          this.$router.replace(queryString);

          let total;
          total = this.$t("{total} results").replace("{total}", this.total);

          document.querySelector(".results-count").innerText = total;

          //this.$emit('loaded', response.data, this.filterParams);
          this.loaded(response.data, this.filterParams);
        });

      this.scrollToTop();
    },

    loaded(result, filterParams) {
      let map = this.$store.getters.getMap;
      if (map === null) {
        this.$store.commit("setMap", new Map());
        map = this.$store.getters.getMap;
        map.create(this.$parent.$refs["catalog-map"], FILTER.location.latlng);
      }
      map.setItems(result.data, filterParams);

      this.isLoaded = true;
    },

    goHome() {
      if (!this.sidebarDisplay) this.toggleDisplaySidebar(true);
    },

    async setFields() {
      await this.$http
        .get("companies", {
          params: {
            request_method: "get_fields",
          },
        })
        .then((response) => {
          this.$refs.filter.hydrateFields(response.data);
        });
    },

    filterSubmit(data) {
      let params = cloneDeep(data);
      params.price = pickBy(params.price, (value) => {
        return !isNull(value);
      });

      this.filterParams = params;
      this.load(data);
    },

    sortingSubmit() {
      this.params.page = 1;
      this.load();
    },

    setPage(num) {
      this.params.page = num;
      this.load();
    },

    perPage(val) {
      this.params.page = 1;
      this.params.per_page = val;
      this.load();
    },
    scrollToTop() {
      $(".catalog__blocks").animate({ scrollTop: 0 }, 300);
    },
    isSearch() {
      return this.$route.name === "search";
    },
    isListening(name) {
      return this.$store.getters.getPopstsateListener(name);
    },
    isCompany() {
      return (
        this.$route.name === "company_found_by_word" ||
        this.$route.name === "company"
      );
    },
    isSearchByWord() {
      return this.$route.name === "search_by_word";
    },
    hideFilterBtn(filter_btn) {
      filter_btn.style.setProperty("display", "none");
    },
    showFilterBtn(filter_btn) {
      filter_btn.style.removeProperty("display");
    },
    windowActions() {
      let filter_btn = document.querySelector(".filter-btn");
      let sidebar = this.$store.getters.getRef("sidebar");

      this.setMetaTitles();

      if (window.screen.width <= 768) {
        switch (true) {
          case this.isSearchByWord():
            this.showFilterBtn(filter_btn);
            this.$store.commit("setDisplayFilter", false);
            this.$store.commit("setCatalogBlocksView", true);
            break;
          case this.isSearch():
            this.showFilterBtn(filter_btn);
            this.$store.commit("setDisplayFilter", false);
            this.toggleDisplaySidebar(true);
            this.$store.commit("setCatalogBlocksView", true);
            if (sidebar !== null && typeof sidebar !== "undefined")
              sidebar.classList.remove("company-shown");
            break;
          case this.isCompany():
            this.$store.commit("setDisplayFilter", false);
            this.$store.commit("setCatalogBlocksView", false);
            if (sidebar !== null && typeof sidebar !== "undefined")
              sidebar.classList.add("company-shown");
            break;
        }
        return;
      }

      switch (true) {
        case this.isSearchByWord():
          this.$store.commit("setDisplayFilter", true);
          this.$store.commit("setCatalogBlocksView", true);
          break;
        case this.isSearch():
          this.$store.commit("setDisplayFilter", true);
          this.$store.commit("setCatalogBlocksView", true);
          if (sidebar !== null && typeof sidebar !== "undefined")
            sidebar.classList.remove("company-shown");
          break;
        case this.isCompany():
          this.$store.commit("setCatalogBlocksView", true);
          this.$store.commit("setDisplayFilter", false);
          if (sidebar !== null && typeof sidebar !== "undefined")
            sidebar.classList.add("company-shown");
          break;
      }
    },
    filterBehavior(state) {
      this.$store.commit("setKey", {
        name: "price",
        value: this.$store.getters.getKey("price") + 1,
      });
      this.$store.commit("setKey", {
        name: "radius",
        value: this.$store.getters.getKey("radius") + 1,
      });

      if (window.screen.width <= 768) {
        switch (true) {
          case this.isSearchByWord():
            this.$store.commit("setDisplayFilter", state);
            this.$store.commit("setCatalogBlocksView", !state);
            break;
          case this.isSearch():
            this.$store.commit("setDisplayFilter", state);
            this.$store.commit("setCatalogBlocksView", !state);
            break;
          case this.isCompany():
            this.$store.commit("setDisplayFilter", state);
            this.$store.commit("setCatalogBlocksView", false);
            this.$store.commit("setCompanyView", !state);
            break;
        }

        return;
      }

      this.$store.commit("setDisplayFilter", state);
    },
    setMetaTitles() {
      let category = this.$store.getters.getCategory(this.$route.params.id),
        meta_title = "";

      switch (true) {
        case typeof category !== "undefined" && this.$route.query.page:
          this.$store.commit(
            "setMetaTitle",
            category.title +
              " " +
              this.$t("Page") +
              ":" +
              " " +
              this.$route.query.page
          );
          this.$store.commit(
            "setH1",
            category.title +
              " " +
              this.$t("Page") +
              ":" +
              " " +
              this.$route.query.page
          );
          break;
        case typeof category !== "undefined":
          this.$store.commit("setMetaTitle", category.title);
          this.$store.commit("setH1", category.title);
          break;
        case this.$route.query.page !== undefined &&
          this.$route.query.search !== undefined:
          meta_title =
            this.$t("Search") +
            ": " +
            this.$route.query.search +
            " " +
            this.$t("Page") +
            ":" +
            " " +
            this.$route.query.page;
          this.$store.commit("setMetaTitle", meta_title);
          this.$store.commit("setH1", meta_title);
          break;
        case this.$route.query.search:
          this.$store.commit("setMetaTitle", this.$route.query.search);
          this.$store.commit("setH1", this.$route.query.search);
          break;
      }

      this.$store.commit("triggerDynamicH1Resize");
    },
  },
};
</script>
